import {
  SUCCESS_API_CONFIRM_DEVICE_AUTH,
  SUCCESS_API_CHECK_DEVICE_AUTH_CODE,
  ERROR_API_CHECK_DEVICE_AUTH_CODE,
  RESET_DEVICE_AUTH_ERROR,
  SUCCESS_API_GET_ACCESS_CONTROL_OPERATORS,
  SUCCESS_API_GET_DEVICE_AUTH_SETTINGS,
  SUCCESS_API_GET_DEVICE_AUTH_SUBSCRIPTION_SETTINGS,
} from '../actions/actionTypes';

export const appInitialState = {
  requiredDeviceAuth: null, // デバイス認証が必要かどうかの真偽値
  deviceAuthToken: '', // デバイス認証トークン
  isDeviceAuthFailed: false, // デバイス認証に失敗したかどうかの真偽値
  operators: [], // メール送信先の選択肢
  deviceAuthSettings: {
    isEnabled: null,
    ipAddresses: [], // 有効なIPアドレス一覧
    subscriptions: [], // デバイス認証に関するメール受信対象ユーザーID一覧
  }, // デバイス認証設定
};

export default (state = appInitialState, action) => {
  switch (action.type) {
    case SUCCESS_API_CONFIRM_DEVICE_AUTH: {
      // デバイス認証確認APIの成功アクションが発行された場合の処理
      return {
        ...state,
        requiredDeviceAuth: action.payload.requiredDeviceAuth,
      };
    }
    case SUCCESS_API_CHECK_DEVICE_AUTH_CODE: {
      // デバイス認証コードによるデバイス認証が成功した場合の処理
      return {
        ...state,
        deviceAuthToken: action.payload.deviceAuthToken,
        requiredDeviceAuth: false, // コード認証成功時にデバイス認証が必要な状態を解除する
      };
    }
    case ERROR_API_CHECK_DEVICE_AUTH_CODE: {
      // デバイス認証コードによるデバイス認証が失敗した場合の処理
      return {
        ...state,
        isDeviceAuthFailed: true,
      };
    }
    case RESET_DEVICE_AUTH_ERROR: {
      // デバイス認証エラーステータスを元に戻す
      return {
        ...state,
        isDeviceAuthFailed: false,
      };
    }
    case SUCCESS_API_GET_ACCESS_CONTROL_OPERATORS: {
      const operators = action.payload.operators || [];
      return { ...state, operators };
    }
    case SUCCESS_API_GET_DEVICE_AUTH_SETTINGS: {
      const { isEnabled, ipAddresses } = action.payload;
      return {
        ...state,
        deviceAuthSettings: {
          isEnabled,
          ipAddresses,
        },
      };
    }
    /**
     * デバイス認証の通知先一覧を取得APIの成功アクションが発行された場合の処理
     */
    case SUCCESS_API_GET_DEVICE_AUTH_SUBSCRIPTION_SETTINGS: {
      const subscriptions = action.payload.subscriptions || [];
      return {
        ...state,
        deviceAuthSettings: {
          ...state.deviceAuthSettings,
          subscriptions,
        },
      };
    }
    default:
      return state;
  }
};
